module.exports = __webpack_public_path__ + "img/alarmImg.ba95c48a.png";